import type { LowPrices } from '@aviata/platform-client';

import { sentryModel } from '@/shared/model';

import type { FetchLowPrices } from './types';

export function fetchLowPrices({
  fetchLowPrices,
  params,
}: {
  fetchLowPrices: FetchLowPrices;
  params: LowPrices.V2.ExtendedSearchCalendarParams;
}) {
  return fetchLowPrices(params)
    .then(data => {
      return data;
    })
    .catch(error => {
      sentryModel.captureException(
        sentryModel.getReadableError(
          sentryModel.createCustomErrorText(
            sentryModel.errorPrefix.DEFAULT,
            'ERR_FAILED_TO_FETCH_LOW_PRICES_V2',
          ),
          error,
        ),
      );
      throw error;
    });
}
